<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";

import { config } from "@/config";
import { useUserStore } from "@/stores";
import { UserType, type WriteAssistantPromotion } from "@/types";

import LeBetaBanner from "./LeBetaBanner.vue";
import LeExamBanner from "./LeExamBanner.vue";
import LeInternalBanner from "./LeInternalBanner.vue";
import LeWriteAssistantBanner from "./LeWriteAssistantBanner.vue";

const route = useRoute();
const userStore = useUserStore();

// Proxy component for top banner, to avoid fragmenting conditional banner-conditions
const { isInternalSite, isMobile, isBetaSite } = config.app;

const isExamRelevant = ref<boolean>(false);
const writeAssistantPromotion = ref<WriteAssistantPromotion | null>(null);

onBeforeMount(async () => {
  const userData = await userStore.getUser();

  if (userData.credentials.type === UserType.Unilogin && userData.credentials.uniloginFunction === "teacher") {
    isExamRelevant.value = true;
  } else if (!isMobile && route.meta.isSearchRoute && userData.featureFlags.availableWriteAssistantPromotion) {
    writeAssistantPromotion.value = userData.featureFlags.availableWriteAssistantPromotion;
  }
});
</script>

<template>
  <LeInternalBanner v-if="isInternalSite" />
  <LeBetaBanner v-if="isBetaSite" />
  <LeExamBanner v-if="isExamRelevant" />
  <LeWriteAssistantBanner v-if="writeAssistantPromotion" :promotion="writeAssistantPromotion" />
</template>
